import PageHeader from './PageHeader';
import { PageHeaderProps, PageHeaderValueProps } from './types';

export type { PageHeaderProps, PageHeaderValueProps };
export default PageHeader;
